module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/home/fireplace-722510cedca4e50365a4cac740178e35.svg";